import {Component} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {ChatVersions} from "../../../../../shared/chat.versions";

import {RouterModule} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'main-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['../main.pages.scss'],
    standalone: true,
    imports: [
    RouterModule,
    TranslateModule
]
})
export class FooterComponent {
    protected showQ_A = environment.chatVersion === ChatVersions.SX
    protected showBlog = environment.chatVersion === ChatVersions.SX
}
